import React, { useState, useEffect } from "react";
import hero1 from "../assets/hol2.jpg";
import hero2 from "../assets/hol3.jpg";
import hero3 from "../assets/hol4.jpg";
import nur16 from "../assets/hol5.jpg";

const Slider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeOut(true);

      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
        setFadeOut(false);
      }, 1000); // wait for fade-out transition
    }, 5500); // delay for each slide

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative overflow-hidden md:h-[90vh] h-[87vh] w-full -mt-16">
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-primary-450 ">
        <img
          src={items[currentIndex].img}
          alt=""
          className="object-cover absolute w-full h-full mix-blend-overlay"
        />
        <div
          className={`absolute md:top-40 top-36 md:left-1/2 transform md:-translate-x-1/2 md:text-center md:px-0 px-4 text-white transition-opacity duration-1000 ease-in-out ${
            fadeOut ? "opacity-0" : "opacity-100"
          }`}
        >
          <h1 className="text-xl md:text-2xl  mt-12 font-bold uppercase">
            {items[currentIndex].name}
          </h1>
          <p className="md:text-[19px] text-[17px] mt-14">
            {items[currentIndex].desc}
          </p>
        </div>

        <button
          className={`animated-button absolute md:top-20 top-16 md:left-20 left-4 text-white bg-accent-400 z-40 p-2 rounded-md transition-opacity duration-1000 ease-in-out ${
            fadeOut ? "opacity-0" : "opacity-100"
          }`}
        >
          {items[currentIndex].buttonText}
        </button>
        {/* Example of second button with different style */}
        <button
          className={`animated-button absolute bottom-36 md:right-28 right-4 text-white bg-primary-400 z-40 p-2 rounded-md transition-opacity duration-1000 ease-in-out ${
            fadeOut ? "opacity-0" : "opacity-100"
          }`}
        >
          {items[currentIndex].buttonText}
        </button>
      </div>
    </div>
  );
};

export default Slider;

const items = [
  {
    img: hero1,
    name: "Welcome TO (HVTC)",
    desc: "Welcome to Holy Vision Technical Campus (HVTC) in Kathmandu. We nurture future engineers and innovators with top-notch facilities and faculty.",
    buttonText: "Tel : 01-5244745 , 014793874",
  },
  {
    img: hero2,
    name: "What makes an individual different ?",
    desc: "An individual's uniqueness stems from their distinct experiences, perspectives, and talents. Personal values and choices further shape their singular identity.",
    buttonText: "Email : hvtcampus@gmail.com",
  },
  {
    img: hero3,
    name: "Friendly teaching and learning environment",
    desc: "A friendly teaching and learning environment promotes respect, collaboration, and a love for learning.",
    buttonText: "गुणस्तरीय प्राविधिक शिक्षाका लागि (HTVC)",
  },
  {
    img: nur16,
    name: "Established (HVTC) 2060",
    desc: "Founded in 2060, HVTC is dedicated to cultivating future engineers and innovators through advanced facilities and expert faculty.",
    buttonText: "Thapaguan, New Baneshwor  Kathmandu",
  },
];
